import React from "react";
import "./CharactersPage.css";
import CharactersCard from "./CharactersCard";
import NavbarClass from "../NavbarClass";
import Footer from "../footer/Footer";
import { characterAltMapping } from "../../utils";
import { pageview } from "../../utils/googleAnalyticsUtils";
import { InView } from "react-intersection-observer";

class CharactersPage extends React.Component {

  componentDidMount() {
    pageview('Characters');
  }

  render() {
    return (
      <div className="characters-page-outer">
        <NavbarClass />

        {/* Banner header */}
        <div className="characaters-header-img-container">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/characters_header_pc.webp`}
              width="1800"
              height="360"
              alt="Meet the Characters banner"
            />
            <img
              src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/characters_header_mob.webp`}
              width="800"
              height="400"
              className="w-100"
              alt="Meet the Characters banner"
            />
          </picture>
        </div>

        {/* Characters grid */}
        <section className="characters-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="hp-section-heading text-center">Meet the Characters</h2>
            </div>

            <InView threshold={0.1} triggerOnce>
              {({ inView, ref }) => (
                <div
                  ref={ref}
                  className={`row hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}
                >
                  {Object.keys(characterAltMapping).map((character, key) => (
                    <CharactersCard
                      key={key}
                      character={character}
                      alt={characterAltMapping[character]}
                      img={`${process.env.REACT_APP_AWS_IMG_CDN}/characters/${character}.svg`}
                    />
                  ))}
                </div>
              )}
            </InView>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default CharactersPage;
